module.exports = __webpack_public_path__ + "static/media/fitz.4a05f403.png";